import { render, staticRenderFns } from "./Chart3.vue?vue&type=template&id=65882250"
import script from "./Chart3.vue?vue&type=script&lang=js"
export * from "./Chart3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports